var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dialog-transparent-component",on:{"pointerover":_vm.onMouseOver,"pointerout":_vm.onMouseOut}},[_vm._v("透過")])}
var staticRenderFns = []

export { render, staticRenderFns }